import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Personvern from "../pages/personvern/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/personvern",
    element: <Personvern />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
